import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** File property - Definition */
export class DocsBlockFilePropertyDefinition extends DocsBlockPropertyDefinition {
}
